module.exports = __webpack_public_path__ + "static/media/m-blog-bg.791423f3.png";